function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import colors from "styles/colors";
import classnames from "classnames";
import { SECONDARY_BUTTON_TYPE, SIGNUP_BUTTON_TYPE, SIGNUP_COMBO_BUTTONS_TYPE } from "segments/desktop/core-components/button/button-consts";
import { XS } from "components/core/new-button/button-component";
import { StyledProductCardGridDekstopComponent } from "./product-card-grid-component.scss";
import ProductCardGridBodyComponent from "./product-card-grid-body-component.js";
import { productCardsImages, productIndexToProductType } from "segments/desktop/grid/layouts/product-cards-grid/default-props";
import { PRODUCTS_THEMES } from "/constants/products";
const ProductCardGridDekstopComponent = (props)=>{
    var _productCardsImages_productType, _productCardsImages_productIndexToProductType_index, _productCardsImages_productType1;
    const { isAtLeastOneCardHighlighted, isHighlighted, header, body, showDivider, useCases, buttonConfig, index, productType } = props;
    const productTheme = productType ? PRODUCTS_THEMES[productType] : PRODUCTS_THEMES[productIndexToProductType[index]];
    const dividerStyle = {
        borderImageSource: `linear-gradient(to right, ${colors[productTheme]}ff, ${colors[productTheme]}00)`
    };
    const getProductButtonConfig = ()=>{
        switch(buttonConfig.buttonType){
            case SIGNUP_BUTTON_TYPE:
                return _object_spread_props(_object_spread({}, buttonConfig), {
                    invert: true,
                    buttonSize: XS
                });
            case SIGNUP_COMBO_BUTTONS_TYPE:
                return _object_spread_props(_object_spread({}, buttonConfig), {
                    signupButtonConfig: _object_spread_props(_object_spread({}, buttonConfig.signupButtonConfig), {
                        invert: true,
                        buttonSize: XS
                    })
                });
            default:
                return buttonConfig;
        }
    };
    const productCardButtonConfig = getProductButtonConfig();
    const imageProp = productType ? productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType = productCardsImages[productType]) === null || _productCardsImages_productType === void 0 ? void 0 : _productCardsImages_productType.image : productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productIndexToProductType_index = productCardsImages[productIndexToProductType[index]]) === null || _productCardsImages_productIndexToProductType_index === void 0 ? void 0 : _productCardsImages_productIndexToProductType_index.image;
    return /*#__PURE__*/ _jsxs(StyledProductCardGridDekstopComponent, {
        className: classnames("product-card", {
            highlighted: isHighlighted
        }, {
            "is-at-least-one-card-highlighted": isAtLeastOneCardHighlighted
        }),
        style: {
            "--color": `linear-gradient(0deg,${colors[productTheme]}ff,${colors[productTheme]}00)`
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "product-card-header",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-card-header-image",
                        children: /*#__PURE__*/ _jsx("a", {
                            tabIndex: "-1",
                            target: "_blank",
                            href: productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType1 = productCardsImages[productType]) === null || _productCardsImages_productType1 === void 0 ? void 0 : _productCardsImages_productType1.url,
                            children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, imageProp))
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-card-header-subtitle",
                        children: header === null || header === void 0 ? void 0 : header.subtitleText
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(ProductCardGridBodyComponent, {
                    body: body,
                    showDivider: showDivider,
                    dividerStyle: dividerStyle,
                    useCases: useCases,
                    theme: productTheme,
                    productCardButtonConfig: productCardButtonConfig
                })
            })
        ]
    });
};
ProductCardGridDekstopComponent.defaultProps = {
    showDivider: true,
    buttonConfig: {
        buttonType: SECONDARY_BUTTON_TYPE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true
    }
};
export default ProductCardGridDekstopComponent;
